import { useEffect, useRef, useState } from "react";
import { routePath } from "../../app/routes/routepath";
import { userLoginReq } from "../../api/authApi/loginReq";
import { useNavigate } from "react-router-dom";
import "../auth/loginpage.css";
import logoImg from "../../assets/logos/white-logo.svg";
import Loader from "../../app/constants/Loader/loader";
import { toast } from "react-toastify";
import { Key, Radius } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDisplay,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";

const LoginPage = () => {
  const navigate = useNavigate();
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setshowPassword] = useState(false);
  const [EmailWarning, setEmailWarning] = useState(false);
  const inputRef = useRef([]);
  const Models = {
    LoginModel: 0,
    ForgotModel: 1,
    EnterOTPModel: 2,
    ResetpasswordModel: 3,
  };

  const emailRejex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
  const [showModel, setshowModel] = useState(Models.LoginModel);

  useEffect(() => {
    if (sessionStorage.getItem("showModel")) {
      sessionStorage.removeItem("showModel");
      sessionStorage.removeItem("email");
    }
  }, []);
  // const handletoast = () => {
  //   console.log("clicked contact to support");
  //   const email_link =
  //     "https://mail.google.com/mail/?view=cm&fs=1&to=support@techfeatures.com";
  //   window.open(email_link, "_blank");
  // };

  const onSubmit = async () => {
    if (!Email || !Password) {
      toast.error("Email and Password are required!");

      return;
    } else if (!emailRejex.test(Email)) {
      setEmailWarning(true);
      return;
    }
    setIsLoading(true);
    try {
      const res = await userLoginReq({
        Email: Email,
        password: Password,
      });

      const result = res?.data?.Result ?? res?.data?.data?.result;

      if (result === 1) {
        navigate(routePath.dashboard);
      } else if (result === -1) {
        // Deleted user
        toast.error("User is no longer part of our system.");
      } else if (result === -2) {
        // Deactivated user
        toast.error(
          "Account restricted, please contact Support Team at support@techfeature.in"
        );
      } else {
        // Incorrect password
        toast.error("Invalid email or password.");
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  const togglePassword = () => {
    if (!showPassword) {
      setshowPassword(true);
    } else if (showPassword) {
      setshowPassword(false);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Enter") {
      inputRef.current[index + 1]?.focus();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "email") {
      setEmail(value);
      setEmailWarning(false);
    } else if (name === "password") {
      setPassword(value);
    }
  };
  return (
    <>
      {showModel === Models.LoginModel && (
        <div className="form_wraper">
          <div className="form-section">
            <img src={logoImg} alt="TechFeatures" className="logo" />
            <h1>Welcome Back</h1>
            <p>Hey, Welcome back to Tech Features!</p>
            <div className="login_form">
              {/* <div className="login_input_wraper">
              <i className="bi bi-people"></i>
              <select
                required
                value={Role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option>Select Role</option>
                <option value="SuperAdmin">SuperAdmin</option>
                <option value="Admin">Admin</option>
              </select>
            </div> */}
              <div className="login_input_wraper">
                <i className="bi bi-envelope"></i>
                <input
                  name="email"
                  ref={(e) => {
                    inputRef.current[0] = e;
                  }}
                  type="email"
                  placeholder="demo@gmail.com"
                  required
                  value={Email}
                  onChange={handleChange}
                  onKeyDown={(e) => handleKeyDown(e, 0)}
                />
              </div>
              {EmailWarning && (
                <span className="error-text" role="alert">
                  Please enter a valid email address
                </span>
              )}
              <div className="login_input_wraper">
                <i className="bi bi-lock"></i>
                <input
                  name="password"
                  ref={(e) => {
                    inputRef.current[1] = e;
                  }}
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  required
                  value={Password}
                  onChange={handleChange}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      onSubmit();
                    }
                  }}
                />
                <span
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    position: "absolute",
                    top: "23px",
                    right: "9px",
                    color: "white",
                  }}
                  onClick={togglePassword}
                >
                  <FontAwesomeIcon
                    style={{ fontSize: "14px" }}
                    icon={!showPassword ? faEyeSlash : faEye}
                  />
                </span>
              </div>

              <div className="Forgot_Password">
                <span
                  onClick={() => {
                    navigate(`${routePath.forgotPassword}`);
                  }}
                >
                  Forgot Password
                </span>
              </div>

              <button
                type="button"
                onClick={onSubmit}
                className="primary_btn w-100"
              >
                Sign In
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoginPage;
